export default "__VITE_ASSET__BbXkHSJ9__"